import { FormTypes } from '../models/form';

// export const defaultFormLanguage = 'vi-VN';

export enum NotificationPayloadType {
  MENTION_ON_A_COMMENT = 'MENTION_ON_A_COMMENT',
  ADDED_YOU_TO_TEAM = 'ADDED_YOU_TO_TEAM',
  ADDED_YOU_TO_WORKSPACE = 'ADDED_YOU_TO_WORKSPACE',
  ADDED_FORM = 'ADDED_FORM',
}

export const defaultLabels = {
  CONFIRM_ANSWER_BUTTON_TEXT: {
    label: 'Button to confirm answer',
    value: 'OK',
    group: 'BUTTONS, HINTS, SHORTCUTS',
  },
  KEYBOARD_INSTRUCTION_TO_GO_NEXT_QUESTION: {
    label: 'Keyboard instruction to go next question',
    value: 'press Enter',
    group: 'BUTTONS, HINTS, SHORTCUTS',
  },
  HINT_FOR_MULTIPLE_SELECTION: {
    label: 'Hint for multiple selection',
    value: 'Choose as many as you like',
    group: 'BUTTONS, HINTS, SHORTCUTS',
  },
  INSTRUCTION_FOR_DROPDOWN_QUESTION: {
    label: 'Instruction for dropdown question',
    value: 'Type or select an option',
    group: 'BUTTONS, HINTS, SHORTCUTS',
  },
  INSTRUCTION_FOR_DATE_INPUT: {
    label: 'Instruction for date input',
    value: 'Pick a date',
    group: 'BUTTONS, HINTS, SHORTCUTS',
  },
  LABEL_FOR_OTHER_ANSWER_OPTION: {
    label: 'Label for "Other" answer question',
    value: 'Other',
    group: 'BUTTONS, HINTS, SHORTCUTS',
  },
  HINT_FOR_ADDING_TEXT: {
    label: 'Hint for adding text',
    value: 'Please enter your response',
    group: 'BUTTONS, HINTS, SHORTCUTS',
  },
  BUTTON_TO_RESPONSE_YES: {
    label: 'Button to response yes',
    value: 'Yes',
    group: 'BUTTONS, HINTS, SHORTCUTS',
  },
  BUTTON_TO_RESPONSE_NO: {
    label: 'Button to response no',
    value: 'No',
    group: 'BUTTONS, HINTS, SHORTCUTS',
  },
  BUTTON_TO_SEND_FORM: {
    label: 'Button to send, submit form',
    value: 'Submit',
    group: 'BUTTONS, HINTS, SHORTCUTS',
  },
  ERROR_IF_AN_ANSWER_IS_REQUIRED: {
    label: 'If an answer is required',
    value: 'Please fill this in',
    group: 'ERROR MESSAGES',
  },
  ERROR_IF_AN_ANSWER_REQUIRES_A_SELECTION: {
    label: 'If an answer is required',
    value: 'Oops, Please make a selection',
    group: 'ERROR MESSAGES',
  },
  ERROR_IF_AN_EMAIL_ADDRESS_IS_INCORRECT: {
    label: 'If an email address is incorrect',
    value: "Hmm…that email doesn't look valid",
    group: 'ERROR MESSAGES',
  },
  ERROR_IF_A_WEBSITE_IS_INCORRECT: {
    label: 'If a website is incorrect',
    value: "Hmm…that website doesn't look valid",
    group: 'ERROR MESSAGES',
  },
  FILE_UPLOAD_BUTTON_TEXT: {
    label: 'Button that asks respondent to upload a file',
    value: 'Click or drag file to this area to upload',
    group: 'FILE UPLOADS',
  },
  FILE_UPLOAD_ERROR_FILE_TO_BIG: {
    label: 'Error when respondent uploads a file that exceeds the size limit',
    value: 'Your file is too big. Max is 2MB!',
    group: 'FILE UPLOADS',
  },
  FILE_UPLOAD_YOUR_FILE_STILL_UPLOADING: {
    label: 'Message telling respondent that file is still uploading',
    value: 'Your file is still uploading, please wait...',
    group: 'FILE UPLOADS',
  },
};

export const TeamPermissions = [
  { value: 'canViewCreateTab', label: 'Can view create' },
  { value: 'canEditCreateTab', label: 'Can edit create' },
  { value: 'canViewShareTab', label: 'Can view share' },
  { value: 'canEditShareTab', label: 'Can edit share' },
  { value: 'canViewConnectTab', label: 'Can view connect' },
  { value: 'canEditConnectTab', label: 'Can edit connect' },
  { value: 'canViewResultsTab', label: 'Can view results' },
  { value: 'canEditResultsTab', label: 'Can edit results' },
  { value: 'canPublishForm', label: 'Can publish form' },
];

export const DefaultTeamPermissions = [
  'canViewCreateTab',
  'canViewShareTab',
  'canViewConnectTab',
  'canEditCreateTab',
  'canEditShareTab',
  'canEditConnectTab',
];

export const publicThemes = {
  DEFAULT_THEME: {
    _id: 'e71b0dcc-b32f-498e-a96a-2de591ae3675',
    name: 'Default theme',
    fontFamily: 'Work Sans',
    questions: '#000000',
    answers: '#643ced',
    buttons: '#643ced',
    background: '#FFFFFF',
    backgroundImage: null,
  },
  PLAIN_BLUE: {
    _id: 'b618337c-e9b2-41e5-85c6-3471c043c362',
    name: 'Plain blue',
    fontFamily: 'Quicksand',
    questions: '#3D3D3D',
    answers: '#4FB0AE',
    buttons: '#4FB0AE',
    background: '#FFFFFF',
    backgroundImage: null,
  },
  PLAIN_SUN: {
    _id: 'd85b42d3-0516-4708-bf97-936da0610ee1',
    name: 'Plain sub',
    fontFamily: 'Bitter',
    questions: '#b89837',
    answers: '#e4ba3f',
    buttons: '#e4ba3f',
    background: '#FFFFFF',
    backgroundImage: null,
  },
  PLAIN_MUD: {
    _id: 'ab6ec370-37e1-4087-b198-d2be06097397',
    name: 'Plain mud',
    fontFamily: 'Merriweather Sans',
    questions: '#9f5318',
    answers: '#cb732b',
    buttons: '#cb732b',
    background: '#FFFFFF',
    backgroundImage: null,
  },
  PLAIN_GRASS: {
    _id: '25fb4b9b-e768-4657-8dce-ddc7936ad41a',
    name: 'Plain grass',
    fontFamily: 'Roboto Condensed',
    questions: '#5b9d6f',
    answers: '#7dbb91',
    buttons: '#7dbb91',
    background: '#FFFFFF',
    backgroundImage: null,
  },
  PLAIN_PURPLE: {
    _id: 'b0e56353-b021-4270-be99-272e14157ee8',
    name: 'Plain purple',
    fontFamily: 'Hepta Slab',
    questions: '#7a3d7c',
    answers: '#c384c5',
    buttons: '#c384c5',
    background: '#FFFFFF',
    backgroundImage: null,
  },
  PLAIN_RASPBERRY: {
    _id: 'd66aa50a-a667-4710-a6bf-63156e313369',
    name: 'Plain raspberry',
    fontFamily: 'Encode Sans',
    questions: '#8b3249',
    answers: '#c75875',
    buttons: '#c75875',
    background: '#FFFFFF',
    backgroundImage: null,
  },
  PLAIN_DARK: {
    _id: 'a7b38928-58b9-4d45-a09c-e7e865f1a518',
    name: 'Plain dark',
    fontFamily: 'Dancing Script',
    questions: '#37404a',
    answers: '#5c5c5c',
    buttons: '#5c5c5c',
    background: '#FFFFFF',
    backgroundImage: null,
  },
  ART_SPLASH: {
    _id: 'be1eaef6-aa00-4a8b-84f5-38d18c6c06df',
    name: 'Dreamie',
    fontFamily: 'Grandstander',
    questions: '#53625f',
    answers: '#53625f',
    buttons: '#c999a3',
    background: '#f0e2e2',
    backgroundImage: 'https://formtory-dev.s3.ap-southeast-1.amazonaws.com/2021/10/11/1633952452077-11.jpg',
  },
  PAPER_INVITE: {
    _id: '364627ca-1176-493d-9e30-c059a8a3f8ff',
    name: 'Buttercup',
    fontFamily: 'Bitter',
    questions: '#000000',
    answers: '#000000',
    buttons: '#5a7036',
    background: '#c83755',
    backgroundImage: 'https://formtory-dev.s3.ap-southeast-1.amazonaws.com/2021/10/14/1634172185970-Theme%20s%E1%BA%B5n%209.jpg',
  },
  MYSTERY: {
    _id: 'e296f00d-229f-4b2b-8c64-afef20054ff9',
    name: 'Moana',
    fontFamily: 'Josefin Sans',
    questions: '#ffffff',
    answers: '#ffffff',
    buttons: '#102960',
    background: '#799579',
    backgroundImage: 'https://formtory-dev.s3.ap-southeast-1.amazonaws.com/2021/10/14/1634171709935-24.jpg',
  },
  SPACE_BOY: {
    _id: 'ea96dc29-c62f-479d-aedd-9bfe7a30aeba',
    name: 'Greenie',
    fontFamily: 'Maven Pro',
    questions: '#000000',
    answers: '#000000',
    buttons: '#c96923',
    background: '#a4b992',
    backgroundImage: 'https://formtory-dev.s3.ap-southeast-1.amazonaws.com/2021/10/14/1634174121781-Theme%20s%E1%BA%B5n%2012.jpg',
  },
};

export const AlphabetCharacters = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'X',
  'Y',
  'Z',
];

export const conditions = {
  IS: {
    value: 'IS',
    label: 'is',
  },
  IS_NOT: {
    value: 'IS_NOT',
    label: 'is not',
  },
  IS_EQUAL_TO: {
    value: 'IS_EQUAL_TO',
    label: 'is equal to',
  },
  IS_NOT_EQUAL_TO: {
    value: 'IS_NOT_EQUAL_TO',
    label: 'is not equal to',
  },
  BEGINS_WITH: {
    value: 'BEGINS_WITH',
    label: 'begins with',
  },
  ENDS_WITH: {
    value: 'ENDS_WITH',
    label: 'ends with',
  },
  CONTAINS: {
    value: 'CONTAINS',
    label: 'contains',
  },
  DOES_NOT_CONTAINS: {
    value: 'DOES_NOT_CONTAINS',
    label: 'does not contains',
  },
  IS_LOWER_THAN: {
    value: 'IS_LOWER_THAN',
    label: 'is lower than',
  },
  IS_GREATER_THAN: {
    value: 'IS_GREATER_THAN',
    label: 'is greater than',
  },
};

export const IntegrationApps = {
  GOOGLE_SHEETS: 'GOOGLE_SHEETS',
  HUBSPOT: 'HUBSPOT',
  MAILCHIMP: 'MAILCHIMP',
  FACEBOOK_PIXEL: 'FACEBOOK_PIXEL',
  GOOGLE_ANALYTICS: 'GOOGLE_ANALYTICS',
  SLACK: 'SLACK',
  GOOGLE_DRIVE: 'GOOGLE_DRIVE',
  MICROSOFT_TEAM: 'MICROSOFT_TEAM',
  SALESFORCE: 'SALESFORCE',
  ZOHO: 'ZOHO',
  TRELLO: 'TRELLO',
  INTERCOM: 'INTERCOM',
};

export const getConditionsByFormType = formType => {
  switch (formType) {
    case FormTypes[FormTypes.MULTIPLE_CHOICE]:
      return [conditions.IS, conditions.IS_NOT];
    case FormTypes[FormTypes.SHORT_TEXT]:
      return [
        conditions.IS_EQUAL_TO,
        conditions.IS_NOT_EQUAL_TO,
        conditions.BEGINS_WITH,
        conditions.ENDS_WITH,
        conditions.CONTAINS,
        conditions.DOES_NOT_CONTAINS,
      ];
    case FormTypes[FormTypes.LONG_TEXT]:
      return [
        conditions.IS_EQUAL_TO,
        conditions.IS_NOT_EQUAL_TO,
        conditions.BEGINS_WITH,
        conditions.ENDS_WITH,
        conditions.CONTAINS,
        conditions.DOES_NOT_CONTAINS,
      ];
    case FormTypes[FormTypes.STATEMENT]:
      return [];
    case FormTypes[FormTypes.PICTURE_CHOICE]:
      return [conditions.IS, conditions.IS_NOT];
    case FormTypes[FormTypes.YES_NO]:
      return [conditions.IS, conditions.IS_NOT];
    case FormTypes[FormTypes.EMAIL]:
      return [
        conditions.IS_EQUAL_TO,
        conditions.IS_NOT_EQUAL_TO,
        conditions.BEGINS_WITH,
        conditions.ENDS_WITH,
        conditions.CONTAINS,
        conditions.DOES_NOT_CONTAINS,
      ];
    case FormTypes[FormTypes.OPINION_SCALE]:
      return [conditions.IS_EQUAL_TO, conditions.IS_NOT_EQUAL_TO, conditions.IS_LOWER_THAN, conditions.IS_GREATER_THAN];
    case FormTypes[FormTypes.RATING]:
      return [conditions.IS_EQUAL_TO, conditions.IS_NOT_EQUAL_TO, conditions.IS_LOWER_THAN, conditions.IS_GREATER_THAN];
    case FormTypes[FormTypes.DATE]:
      return [conditions.IS_EQUAL_TO, conditions.IS_NOT_EQUAL_TO, conditions.IS_LOWER_THAN, conditions.IS_GREATER_THAN];
    case FormTypes[FormTypes.NUMBER]:
      return [conditions.IS, conditions.IS_NOT, conditions.IS_LOWER_THAN, conditions.IS_GREATER_THAN];
    case FormTypes[FormTypes.DROPDOWN]:
      return [conditions.IS, conditions.IS_NOT];
    case FormTypes[FormTypes.FILE_UPLOAD]:
      return [conditions.IS, conditions.IS_NOT];
    case FormTypes[FormTypes.WEBSITE]:
      return [
        conditions.IS_EQUAL_TO,
        conditions.IS_NOT_EQUAL_TO,
        conditions.BEGINS_WITH,
        conditions.ENDS_WITH,
        conditions.CONTAINS,
        conditions.DOES_NOT_CONTAINS,
      ];
    default:
      return null;
  }
};

export const FormNotifications = {
  defaultSelfSubject:
    `{"blocks":[{"key":"f1nuq","text":"Formtory: New response for [FORM_NAME] ","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":27,"length":11,"key":0}],"data":{}}],"entityMap":{"0":{"type":"mention","mutability":"SEGMENTED","data":{"mention":{"name":"[FORM_NAME]","type":"FORM","displayName":"Form name","id":null}}}}}`,
  defaultSelfMessage: formId => {
    // tslint:disable-next-line:max-line-length
    return `{"blocks":[{"key":"6nd6o","text":"Your form [FORM_NAME] has a new response:","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":10,"length":11,"key":0}],"data":{}},{"key":"3v3te","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"53qnr","text":"[ALL_ANSWERS] ","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":0,"length":13,"key":1}],"data":{}},{"key":"7tteo","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"ga3o","text":"Log in to view or download your responses at","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"fcp73","text":"https://admin.formtory.com/form/${formId}/results","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"6bg8l","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"7ttop","text":"You can turn off or configure self notifications for this form at","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"ajpre","text":"https://admin.formtory.com/form/${formId}/create/notifications","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"7802d","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"foitv","text":"Team Formtory, ","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"bsntl","text":"Thanks, Best Regards!","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{"0":{"type":"mention","mutability":"SEGMENTED","data":{"mention":{"name":"[FORM_NAME]","type":"FORM","displayName":"Form name","id":null}}},"1":{"type":"mention","mutability":"SEGMENTED","data":{"mention":{"name":"[ALL_ANSWERS]","type":"FORM","displayName":"All answers","id":null}}}}}`;
  },
  defaultRespondentSubject: `{"blocks":[{"key":"f1nuq","text":"Formtory: Thank you for filling out [FORM_NAME] ","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":36,"length":11,"key":0}],"data":{}}],"entityMap":{"0":{"type":"mention","mutability":"SEGMENTED","data":{"mention":{"name":"[FORM_NAME]","type":"FORM","displayName":"Form name","id":null}}}}}`,
  // tslint:disable-next-line:max-line-length
  defaultRespondentMessage: `{"blocks":[{"key":"6nd6o","text":"Hello,","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"cmns3","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"3cl31","text":"We've received your submission.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"4mnnp","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"1rn24","text":"Thank you & Have a nice day!","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`,
};

export const FormNotificationsVn = {
  defaultSelfSubject: '{"blocks":[{"key":"f1nuq","text":"Formtory: Phản hồi mới của [FORM_NAME] ","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":27,"length":11,"key":0}],"data":{}}],"entityMap":{"0":{"type":"mention","mutability":"SEGMENTED","data":{"mention":{"name":"[FORM_NAME]","type":"FORM","displayName":"Form name","id":null}}}}}',
  defaultSelfMessage: formId => {
    // tslint:disable-next-line:max-line-length
    return `{"blocks":[{"key":"6nd6o","text":"Biểu mẫu [FORM_NAME] của bạn có 1 phản hồi mới:","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":9,"length":11,"key":0}],"data":{}},{"key":"3v3te","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"53qnr","text":"[ALL_ANSWERS] ","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":0,"length":13,"key":1}],"data":{}},{"key":"7tteo","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"ga3o","text":"Đăng nhập để xem hoặc tải bản báo cáo của bạn tại","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"fcp73","text":"https://admin.formtory.com/form/${formId}/results","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"6bg8l","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"7ttop","text":"Bạn có thể tắt hoặc tùy chỉnh chức năng tự thông báo của biểu mẫu này tại","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"ajpre","text":"https://admin.formtory.com/form/${formId}/create/notifications","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"7802d","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"foitv","text":"Chúc bạn một ngày tốt lành,","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"bsntl","text":"Đội ngũ Formtory.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{"0":{"type":"mention","mutability":"SEGMENTED","data":{"mention":{"name":"[FORM_NAME]","type":"FORM","displayName":"Form name","id":null}}},"1":{"type":"mention","mutability":"SEGMENTED","data":{"mention":{"name":"[ALL_ANSWERS]","type":"FORM","displayName":"All answers","id":null}}}}}`;
  },
  defaultRespondentSubject: `{"blocks":[{"key":"f1nuq","text":"Formtory: Cảm ơn bạn đã trả lời biểu mẫu [FORM_NAME] ","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[{"offset":41,"length":11,"key":0}],"data":{}}],"entityMap":{"0":{"type":"mention","mutability":"SEGMENTED","data":{"mention":{"name":"[FORM_NAME]","type":"FORM","displayName":"Form name","id":null}}}}}`,
  // tslint:disable-next-line:max-line-length
  defaultRespondentMessage: `{"blocks":[{"key":"6nd6o","text":"Xin chào,","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"5h8ke","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"7g528","text":"Chúng tôi đã nhận được phản hồi của bạn.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"m0f5","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"8gm7d","text":"Cảm ơn và chúc bạn một ngày tốt lành!","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`,
};
